import React, { useState, useEffect, useContext } from 'react';

import { useNavigate, Link, Navigate, useParams } from 'react-router-dom';

import { Header, Footer, HeaderBox } from '../../components/imports'

import { WEBROOT, APP_NAME, PHOTOS_ROOT } from '../../constants/general'

import { Text } from '../../constants/Text'

import { Context } from '../../class/Context'

import Func from '../../class/Func'

import Annonces from '../../class/Annonces';
import PlantSitting from '../../class/PlantSitting';

function PsSupprimerAnnonce() {

    const { id } = useParams()

    const navigate = useNavigate()

    const context = useContext(Context)

    const [loading, setLoading] = useState(false)

    const [error, setError] = useState('')

    const [success, setSuccess] = useState('')

    const [annonce, setAnnonce] = useState(false)

    const getAnnonce = async () => {

        let results = await PlantSitting.post('annonceById', { id: id })
    
        if(results.success){

            if(results.data.user_id != localStorage.idU || (results.data.stt != '0' && results.data.stt != '5')) navigate('/404')

            setAnnonce(results.data)
    
        }else{
    
            navigate('/404')
    
        }
    
    }

    
    const action = async (id) => {

        let results = await PlantSitting.post('supprimer', { id: id })

        if (results.success){

            setSuccess(results.message)

        }else{

            setError(results.message)

        }

    }

    useEffect(() => {

        Func.session(context, navigate)

        document.title = "Supprimer une annonce - " + APP_NAME

        window.scrollTo(0, 0)

        getAnnonce()
        
    }, [])


    return (
        <div className="">
            
            <Header />

            <HeaderBox />

        <div className='content pos-r'>

            <div className="c br8 p40 mt20 ta-center">

                <h1 className='cl2 mb20'>Je supprime l'annonce</h1>

                {(error !== '') && <p className="error">{error}</p>}  
                {(success !== '') && <p className="succes">{success}</p>}

                { (success !== '') && <div><Link className='btn bg4 cl1' to={'/mon-profile/articles/plant-sitting'}>Retour profil</Link></div> }

                {

                    success == ''

                    &&

                    <>
                        <p className='mb20'>Cette annonce et les discussions reliées serons supprimées définitivement, confirme ton choix !</p>

                        <span className='btn bg4 cl1 mr10' onClick={e => action(annonce.idA)}>Oui</span>
                        <Link className='btn bg4 cl1' to={'/plant-sitting/annonce/' + annonce.idA}>Non</Link>
                    </>
                    
                }

            </div>

        </div>

            <Footer/>

        </div>   
    )

}

export default PsSupprimerAnnonce